export default __webpack_public_path__ + "static/media/about_four.92446e2b.png";